import React, { useEffect, useState } from "react";
import { FiArrowUp, FiX } from "react-icons/fi";
import { motion } from "framer-motion";

const positionClasses = {
  "bottom-right": "right-4 md:right-6 bottom-4 md:bottom-6",
  "bottom-left": "left-4 md:left-6 bottom-4 md:bottom-6",
};

export default function FloatButton({
  label,
  icon,
  onClick,
  href,
  className = "",
  position = "bottom-right",
  showAt = 0,
  onlyMobile,
  onlyDesktop,
  variant = "default",
  target,
  draggable = false,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY >= showAt);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showAt]);

  if (!visible) return null;

  const responsiveClass = onlyMobile
    ? "flex md:hidden"
    : onlyDesktop
      ? "hidden md:flex"
      : "flex";

  const handleClick = (e) => {
    if (href) {
      if (target === "_blank") {
        window.open(href, "_blank");
      } else {
        window.location.href = href;
      }
      return;
    }

    if (onClick) {
      onClick();
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const baseStyle =
    variant === "default"
      ? "items-center gap-2 rounded-full bg-gradient-to-r from-[#00AEEF] to-[#0099D6] px-3 py-2 md:px-4 md:py-3 shadow-lg shadow-sky-300/60 text-white text-xs md:text-sm font-semibold"
      : "items-center justify-center w-auto h-auto";

  return (
    <motion.button
      type="button"
      onClick={handleClick}
      drag={draggable}
      {...(draggable
        ? {
            dragMomentum: false,
            whileHover: { scale: 1.05 },
            whileTap: { scale: 0.95 },
          }
        : {})}
      className={`fixed z-[99999] ${positionClasses[position]} ${responsiveClass} ${baseStyle} transition-shadow duration-200 ${
        !draggable && "transition-transform duration-200 active:scale-95 hover:scale-105"
      } ${className}`}
    >
      {icon ?? <FiArrowUp className="w-5 h-5 md:w-6 md:h-6" />}
      {variant === "default" && label && (
        <span className="hidden sm:inline whitespace-nowrap">{label}</span>
      )}
    </motion.button>
  );
}
